import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useNavigate } from 'react-router-dom';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import PurchaseInvoiceTable from './PurchaseInvoiceTable';
import VnPagination from '@ui/components/VnPagination';
import { getAllPurchaseInvoiceStatusAsync, getAllPurchaseInvoicesAsync } from '@application/features/purchaseInvoices/purchaseInvoiceThunk';
import { useEffect, useState } from 'react';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const PurchaseInvoice = () => {
    VnDocumentTitle('Visser Inkoopfacturen');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { purchaseInvoices } = useAppSelector((state) => state.purchaseinvoice);
    const handleAddPurchaseInvoiceClick = () => {
        navigate(`/admin/PurchaseInvoicesTabs`);
    };
    useEffect(() => {
        dispatch(getAllPurchaseInvoicesAsync(purchaseInvoiceFilterValues));
        dispatch(getAllPurchaseInvoiceStatusAsync());
    }, []);
    // -------------------------------  grid
    const defaultSortingCriteria = {
        sortColumnKey: 'purchaseInvoiceNumber',
        sortDirection: 'desc'
    };
    const defaultPurchaseInvoiceFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        supplierName: null,
        workorderNumber: null,
        purchaseInvoiceNumber: null,
        invoiceDate: null,
        statusId: null,
        approvedBy: null,
        created: null
    };
    const [purchaseInvoiceFilterValues, setPurchaseInvoiceFilterValues] = useState(defaultPurchaseInvoiceFilterValues);
    const onRowClick = (rowId) => {
        window.open(`/admin/PurchaseInvoicesTabs/${rowId}`, '_blank');
    };
    const updatePurchaseInvoiceFilterValues = (newValues) => {
        setPurchaseInvoiceFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchPurchaseInvoiceHandler(searchText) {
        updatePurchaseInvoiceFilterValues({ filter: searchText });
        dispatch(getAllPurchaseInvoicesAsync({
            ...purchaseInvoiceFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function PurchaseInvoiceSortingHandler(data) {
        updatePurchaseInvoiceFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllPurchaseInvoicesAsync({
            ...purchaseInvoiceFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function onPurchaseInvoicePageChange(pageNumber) {
        updatePurchaseInvoiceFilterValues({ pageNumber });
        dispatch(getAllPurchaseInvoicesAsync({
            ...purchaseInvoiceFilterValues,
            pageNumber
        }));
    }
    function PurchaseInvoiceFilteringHandler(data) {
        data.pageNumber = 1;
        updatePurchaseInvoiceFilterValues(data);
        dispatch(getAllPurchaseInvoicesAsync({
            ...purchaseInvoiceFilterValues,
            ...data
        }));
    }
    // end grid
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '2rem'
                }, children: [_jsx("h4", { children: "Inkoopfacturen" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Inkoopfacturen', onClick: handleAddPurchaseInvoiceClick, isDisabled: !handleRolePermission(Permission.INKOOPFACTUREN, PermissionType.Create) }) })] }), _jsx("div", { className: 'mt-0', children: _jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchPurchaseInvoiceHandler }), _jsx(PurchaseInvoiceTable, { purchaseInvoices: purchaseInvoices?.items, onRowClick: onRowClick, onSorting: PurchaseInvoiceSortingHandler, onFilter: PurchaseInvoiceFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: purchaseInvoices && (_jsx(VnPagination, { currentPage: purchaseInvoices?.pageNumber, totalPages: purchaseInvoices?.totalPages, onPageChange: onPurchaseInvoicePageChange })) })] }) })] }));
};
export default PurchaseInvoice;
